class TabsSlider {
  constructor() {
    this.sections = document.querySelectorAll('.tabs-slider');
    this.init();
  }

  init() {
    if (!this.sections.length) return;

    this.sections.forEach((section) => {
      const tabs = section.querySelectorAll('[data-tab-button]');
      const panels = section.querySelectorAll('[data-tab-panel]');

      if (!tabs.length || !panels.length) return;

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const targetIndex = tab.getAttribute('data-tab-button');

          tabs.forEach((button) => {
            const isActive = button === tab;
            button.classList.toggle('tabs-slider__tab--active', isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.getAttribute('data-tab-panel') === targetIndex;
            panel.classList.toggle('tabs-slider__panel--active', isActive);
          });
        });
      });
    });
  }
}

new TabsSlider();